import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { Box, Button, Grid, Typography, TextField, MenuItem, FormControl, InputLabel, Select, CircularProgress, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, Chip } from '@mui/material';
import Countdown from 'antd/lib/statistic/Countdown';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { GIFT_STATUS , dateFormat } from '../../../utils/settings';
import { 
  SendOtpToGiftReciever,
  SendOtpToMasonGiftReciever,
  UpdateGiftStatus,
  UploadGiftImage,
  VerifyOtpToGiftReciever,
} from '../../../screen/distributor/action/util_action';
import UploadButton from '../../../components/uploadButton/uploadButton';

const SingleGift = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [loader, setLoader] = useState(false);
  const [timer, setTimer] = useState(Date.now());
  const [showOtp, setShowOtp] = useState(true);
  const [images, setImages] = useState([]);
  const [otp, setOtp] = useState('');
 
  const [redeemCodeString, setRedeemCodeString] = useState('');

  const { giftProduct } = useSelector((state) => ({
    giftProduct: state.distributorReducer.giftProduct,
  }));

  const isMason = giftProduct.receiver_company_type === 1;

  const handleupload = (e) => {
    setImages([...images, ...e]);
  };

  const verifyOtp = async () => {
    const { data, error, message } = await VerifyOtpToGiftReciever(
      giftProduct.transaction_id,
      otp
    );
    if (error) return toast.error(message);
    setRedeemCodeString(data.code);
    toast.success('Gift Redeemed Successfully');
  };

  const onFinish = async () => {
    if (images.length === 0 && !giftProduct.gift_product_otp_required) {
      return toast.error('Please Upload Image');
    }

    const obj = {
      transaction_id: giftProduct.transaction_id,
      otp,
      gifted_on: moment(new Date()).format(dateFormat),
      status: giftStatus + 1,
    };

    if (otp && !isMason && redeemCodeString.length === 0) {
      const { error, message } = await verifyOtp();
      if (error) return toast.error(message);
    }

    setLoader(true);
    const { error: error2, message: message2 } = await UpdateGiftStatus(obj);
    setLoader(false);
    if (error2) return toast.error(message2);

    const formData = new FormData();
    images.forEach((img) => formData.append('image_files', img));

    setLoader(true);
    const { error: errorUp, message: messageUp } = await UploadGiftImage(
      giftProduct.transaction_id,
      formData
    );
    setLoader(false);
    if (errorUp) return toast.error(messageUp);

    toast.success('Success');
    navigate('/distributor/gifts');
  };
  const sendOtpHandler = async () => {
    setShowOtp(false);
    setTimer(Date.now() + 30000);
    const sendOtp = isMason ? SendOtpToMasonGiftReciever : SendOtpToGiftReciever;
    const { error, message } = await sendOtp(giftProduct.transaction_id);
    if (error) return toast.error(message);
    toast.success('OTP Sent Successfully');
  };
  const [giftStatus, setGiftStatus] = useState(
    giftProduct.gift_status !== undefined ? giftProduct.gift_status - 1 : 0
  );
  const handleStatusChange = (newStatus) => {
    setGiftStatus(newStatus);
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" textAlign="left" gutterBottom sx={{ fontWeight: 'bold', my: 4, color: 'orange' }}>{t('gifts.rewardsDeatils')}</Typography>
      <TableContainer component={Paper} sx={{ mb:4 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ background: '#f4f6f8', borderBottom: '1px dashed #919eab33' }}>
              <TableCell sx={{ color: '#637381', fontWeight: 'bold', borderBottom: 'none' }}>
                {t('gifts.beneficiarysName')}
              </TableCell>
              <TableCell sx={{ color: '#637381', fontWeight: 'bold', borderBottom: 'none' }}>
                {t('gifts.type')}
              </TableCell>
              <TableCell sx={{ color: '#637381', fontWeight: 'bold', borderBottom: 'none' }}>
                {t('gifts.productName')}
              </TableCell>
              <TableCell sx={{ color: '#637381', fontWeight: 'bold', borderBottom: 'none' }}>
                {t('gifts.status')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{ borderBottom: 'none' }}>
                <div>{giftProduct.receiver_company_name}</div>
                <div style={{ fontSize: '0.9rem', color: 'gray' }}>{giftProduct.receiver_company_phone_no}</div>
              </TableCell>
              <TableCell sx={{ borderBottom: 'none' }}>{giftProduct?.receiver_company_firm_role}</TableCell>
              <TableCell sx={{ borderBottom: 'none' }}>{giftProduct.gift_product_name}</TableCell>
              <TableCell sx={{ borderBottom: 'none', color: '#F49D3F' }}>
                <Chip
                  label={GIFT_STATUS[giftProduct.gift_status - 1]}
                  sx={{ 
                    background : giftProduct.gift_status - 1 ? "#4BB543" : "#F49D3F", 
                    color: '#fff',
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {giftProduct.gift_product_otp_required && (
          <Box mt={3}>
            <FormControl fullWidth>
              <TextField
                label={t('OTP')}
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                inputProps={{ maxLength: 4 }}
              />
            </FormControl>
            {!showOtp ? (
              <Countdown value={timer} onFinish={() => setShowOtp(true)} />
            ) : (
              <Button onClick={sendOtpHandler}>{t('verify.sendOTP')}</Button>
            )}
          </Box>
        )}
        {redeemCodeString && (
          <Typography variant='h6' textAlign='center' mt={2}>
            {redeemCodeString}
          </Typography>
        )}
        {!giftProduct.gift_product_otp_required && (
          <FormControl sx={{width: '50%'}} mt={3}>
            <InputLabel>{t('orderDetails.status')}</InputLabel>
            <Select 
                disabled={giftProduct.gift_status - 1 === 1}
                value={giftStatus}
                onChange={(e) => handleStatusChange(e.target.value)}
                label={t('orderDetails.status')}
              >
                {GIFT_STATUS.map((status, i) => (
                  <MenuItem key={i} value={i}>{status}</MenuItem>
                ))}
              </Select>
          </FormControl>
        )}
        {!giftProduct.gift_product_otp_required && (
          <UploadButton
            disabled={giftProduct.gift_status - 1 === 1}
            label={'Upload Image'}
            text={'Upload Image'}
            id={'images'}
            name={'files'}
            multiple={true}
            onChange={handleupload}
            files={images}
            setFiles={setImages}
          />
        )}
        <Box mt={3}>
          {giftProduct.gift_product_otp_required ? (
            <Button
              disabled={!!redeemCodeString}
              onClick={redeemCodeString ? null : verifyOtp}
              variant='contained' color='warning'>
              Redeem Gift
            </Button>
          ) : (
            <Button onClick={onFinish} variant='contained' color='primary' disabled={loader || giftProduct.gift_status - 1 === 1}>
              {loader ? <CircularProgress size={24} /> : t('gifts.updateStatus')}
            </Button>
          )}
        </Box>
    </Box>
  );
};

export default SingleGift;
